import React, { createContext, Dispatch, PropsWithChildren, useEffect, useState } from 'react';
import { OrganisationUnit } from '@app/models';
import { useGlobalContext } from '../../GlobalContextProvider';

interface ITmsContext {
  error: string;
  setError: Dispatch<string>;
  selectedOu: OrganisationUnit;
  setSelectedOu: Dispatch<OrganisationUnit>;
  selectedTenantId: string;
  setSelectedTenantId: Dispatch<string>;
}

const TmsContext = createContext<ITmsContext | undefined>(undefined);

function TmsContextProvider({ children }: PropsWithChildren) {
  const [error, setError] = useState(undefined as any);
  const [selectedOu, setSelectedOu] = useState(undefined as any);
  const { tenantId, setTenantId } = useGlobalContext();
  useEffect(() => {
    setSelectedOu(undefined);
  }, [tenantId]);

  return (
    <TmsContext.Provider
      value={{
        error,
        setError,
        selectedOu,
        setSelectedOu,
        selectedTenantId: tenantId,
        setSelectedTenantId: setTenantId,
      }}>
      {children}
    </TmsContext.Provider>
  );
}

export { TmsContextProvider, TmsContext };
